import { QRBusiness } from "./qr-business";

export { QRBusiness };
